import { useLanguage } from "@/context/LanguageContext";
import { scrollToSection } from "@/components/Navbar";

export const Footer = () => {
  const { t } = useLanguage();

  return (
    <footer className="border-t border-white/10 bg-card/60" data-testid="site-footer">
      <div className="mx-auto max-w-[1600px] px-4 pb-10 pt-20 sm:px-8 lg:px-16">
        <p className="select-none text-center font-display text-[16vw] font-extrabold uppercase leading-none text-outline-accent lg:text-[11rem]" aria-hidden="true">
          Noste
        </p>

        <div className="mt-16 grid grid-cols-1 gap-10 border-t border-white/10 pt-10 sm:grid-cols-3">
          <div>
            <p className="font-display text-lg font-extrabold uppercase text-ink">Noste<span className="text-accent">.</span></p>
            <p className="mt-2 font-mono text-xs uppercase tracking-[0.25em] text-accent">{t.footer.tagline}</p>
          </div>
          <div>
            <p className="font-mono text-[10px] uppercase tracking-[0.25em] text-dim">{t.footer.navigate}</p>
            <div className="mt-4 flex flex-col gap-2">
              {[
                { id: "services", label: t.nav.services },
                { id: "work", label: t.nav.work },
                { id: "manifesto", label: t.nav.manifesto },
                { id: "studio", label: t.nav.studio },
                { id: "contact", label: t.nav.contact },
              ].map((link) => (
                <a
                  key={link.id}
                  href={`#${link.id}`}
                  onClick={(e) => scrollToSection(e, link.id)}
                  className="text-sm text-mist transition-colors hover:text-accent"
                  data-testid={`footer-link-${link.id}`}
                >
                  {link.label}
                </a>
              ))}
            </div>
          </div>
          <div>
            <p className="font-mono text-[10px] uppercase tracking-[0.25em] text-dim">{t.footer.contactTitle}</p>
            <div className="mt-4 flex flex-col gap-2 text-sm text-mist">
              <a href={`mailto:${t.contact.emailUs}`} className="transition-colors hover:text-accent">{t.contact.emailUs}</a>
              <span>{t.contact.phone}</span>
              <span>{t.contact.address}</span>
            </div>
          </div>
        </div>

        <div className="mt-12 flex flex-col items-center justify-between gap-4 border-t border-white/10 pt-8 sm:flex-row">
          <p className="font-mono text-[10px] uppercase tracking-[0.2em] text-dim">{t.footer.rights}</p>
          <a href="/admin" className="font-mono text-[10px] uppercase tracking-[0.2em] text-dim transition-colors hover:text-accent" data-testid="footer-admin-link">
            {t.footer.admin}
          </a>
        </div>
      </div>
    </footer>
  );
};
